export const ADMIN_DOMAIN = 'admin.aigicare.com';
export const PATIENT_DOMAIN = 'patient.aigicare.com';
